// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FH9w","controls":"styles_controls__1wXQ9","charLimit":"styles_charLimit__2VyON","input":"styles_input__2ufm9","send":"styles_send__3E_9L"};